/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Nya meddelanden i appen',
    titleMeta: 'Visar senaste aviseringar i appen CamAPS FX',
    descriptionMeta: 'Här är texten för de senaste aviseringarna i appen om appuppdateringar, säkerhetsmeddelanden, uppdateringar av användarmanualen',
    keywords: 'meddelanden' ,
    localeMeta: 'sv_se',

    heading: 'Nya meddelanden i appen',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Uppdatering av Android-app (YpsoPump only) 28/10/2026',
    body_132:'Kära CamAPS FX-användare, en ny version av applikationen 1.4(195) kommer att vara tillgänglig inom de närmaste dagarna. Vänligen välj din föredragna uppdateringstid genom att avaktivera den automatiska uppdateringen för CamAPS FX i Google Play Store. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundtjänst.',

    header_131:'',
    body_131:'',

    header_130:'Uppdatering krävs (endast YpsoPump) 20/10/2026',
    body_130:'Uppdatering krävs! Den här versionen av CamAPS FX kan krascha och starta om oftare. Uppdatera till den senaste versionen NU via Google Play Butik. Appversion 1.4(190) kommer att upphöra den 20/11/2026. Efter detta datum kommer “Auto Mode” inte längre att vara tillgängligt förrän appen har uppdaterats. Insulintillförseln via din pump fortsätter.',

    header_129:'',
    body_129:'',

    header_128:'Uppdatering av användarmanual (endast YpsoPump) 15/10/2026',
    body_128:'En uppdaterad version av användarmanualen finns nu tillgänglig. Du kan komma åt den från huvudmenyn i CamAPS FX genom att välja Hjälp efter uppdatering till den senaste appversionen.',

    header_127:'iOS app-uppdatering (YpsoPump only) 08/10/2026',
    body_127:'Kära CamAPS FX-användare, en NY VERSION av applikationen 1.4(196) kommer att vara tillgänglig inom de närmaste dagarna. DEAKTIVERA CamAPS FX AUTOMATISKA UPPDATERINGAR i App Store för att välja din föredragna uppdateringstid. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundservice.',

    header_126:'',
    body_126:'',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 utgåva 11/09/2026',
    body_121:'Apple kommer snart att släppa iOS 27. För att säkerställa oavbruten användning av CamAPS FX-appen, kontrollera kompatibiliteten för smartphone och operativsystem på sensortillverkarens webbplats INNAN du uppdaterar din iPhone till iOS 27. Automatiska uppdateringar kan vara PÅSLAGNA som standard i telefonens inställningar; överväg att stänga AV dem.',

    header_120:'',
    body_120:'',

    header_119:'Uppdatering av användarmanual (endast YpsoPump) 10/09/2026',
    body_119:'En uppdaterad version av användarmanualen finns nu tillgänglig. Du kan komma åt den från huvudmenyn i CamAPS FX genom att välja Hjälp efter uppdatering till den senaste appversionen.',

    header_118:'',
    body_118:'',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'Uppdatering av Android-app (YpsoPump only) 24/08/2026',
    body_113:'Kära CamAPS FX-användare, en ny version av applikationen 1.4(193) kommer att vara tillgänglig inom de närmaste dagarna. Vänligen välj din föredragna uppdateringstid genom att avaktivera den automatiska uppdateringen för CamAPS FX i Google Play Store. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundtjänst.',

    header_112:'',
    body_112:'',

    header_111:'Avaktivering av Android-versioner under 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Kära CamAPS FX-användare, av cybersäkerhetsskäl kommer versioner UNDER 1.4(192) att AVSLUTAS den 31/08/2026. Se till att din app är UPPDATERAD till version 1.4(192) före detta datum. Om du har några frågor, kontakta mylife-Diabetescare kundtjänst.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17-version 24/06/2026',
    body_109:'Android kommer snart att släppa OS 17. För att säkerställa oavbruten användning av CamAPS FX-appen, kontrollera kompatibiliteten för smartphone och operativsystem på sensortillverkarens webbplats INNAN du uppdaterar din Android-enhet till OS 17. Automatiska uppdateringar kan vara PÅSLAGNA som standard i telefonens inställningar; stäng AV dem.',

    header_108:'Dexcom G7 är tillgänglig (endast Ypsopump) 23/06/2026',
    body_108:'Integrationen av Dexcom G7 CGM-systemet är nu tillgänglig! Användare som byter från Dexcom G6 kan hitta en guide för bytet, felsökningshjälp och en översikt över kompatibla CGM-system på vår webbplats: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Uppdatering av användarmanual (endast YpsoPump) 22/06/2026',
    body_106:'En uppdaterad version av användarmanualen finns nu tillgänglig. Du kan komma åt den från huvudmenyn i CamAPS FX genom att välja Hjälp.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Uppdatering av Android-app (YpsoPump only) 12/06/2026',
    body_103:'Kära mylife CamAPS FX-användare, en ny version av applikationen 1.4(192) kommer att vara tillgänglig inom de närmaste dagarna. Vänligen välj din föredragna uppdateringstid genom att avaktivera den automatiska uppdateringen för CamAPS FX i Google Play Store. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundtjänst.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Avslut av äldre operativsystem 22/05/2026',
    body_98:'När vi nu förbereder nästa appuppdatering, ber vi er att notera att CamAPS FX ENDAST kommer att stödjas på sensorkompatibla telefoner som kör OS 13 eller senare eller Apple iOS 18 eller senare. Efter denna version kommer användare med telefoner som kör UNDER OS 13 eller iOS 18 INTE att kunna UPPDATERA eller OMINSTALLERA CamAPS FX.',

    header_97:'Uppdatering av iOS-app 22/05/2026',
    body_97:'Kära CamAPS FX-användare, en ny version av CamAPS FX, 1.4(195), kommer att bli tillgänglig inom de närmaste dagarna. För att själv välja när du vill uppdatera, ska du inaktivera AUTOMATISKA UPPDATERINGAR i App Store. Användare med versioner UNDER Apple iOS 18 kommer INTE att kunna UPPDATERA CamAPS FX till denna version. En uppdaterad version av användarmanualen finns nu tillgänglig. Vid frågor, kontakta mylife-Diabetescare kundservice.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Avaktivering av iOS-versioner under 1.4(193) (endast Ypsopump) 22/04/2026',
    body_93:'Kära CamAPS FX-användare, av cybersäkerhetsskäl kommer VERSIONER UNDER 1.4(193) att AVAKTIVERAS den 30 april. Säkerställ att din app är UPPDATERAD till version 1.4(193) före detta datum. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundservice.',

    header_92:'Utfasning av äldre operativsystem 21/04/2026',
    body_92:'Av cybersäkerhetsskäl kommer mylife CamAPS FX från och med den 30 juni 2026 ENDAST att stödjas på sensorkompatibla telefoner som kör följande operativsystem: Android OS 13 och senare samt Apple iOS 18 och senare. Användare av operativsystem UNDER Android OS 13 eller Apple iOS 18 kommer INTE att kunna UPPDATERA eller INSTALLERA OM mylife CamAPS FX efter detta datum.',

    header_91:'Meddelande från Abbott 01/04/2026',
    body_91:'Viktigt: Från och med den 31 mars 2026 kommer FreeStyle Libre 3 sensorn inte längre att vara tillgänglig. Kontakta din vårdspersonal för att uppdatera ditt recept till den nya FreeStyle Libre 3 Plus sensorn. Läs mer här:',
    body_91_link_text:'FreeStyle Libre 3 System | Continuous Glucose Monitoring | Abbott',
    body_91_end: '.',
    body_91_link:'https://www.freestyle.abbott/se-sv/produkter/freestyle-libre-3-systemet.html',

    header_90:'',
    body_90:'',

    header_89:'Uppdatering av Dexcom G7 (endast Ypsopump) 07/04/2026',
    body_89:'Vi närmar oss! Kompatibilitet mellan CGM-systemet Dexcom G7 och mylife CamAPS FX kommer att vara tillgänglig till sommaren 2026. Vi håller er informerade när lanseringen närmar sig.',

    header_88:'',
    body_88:'',

    header_87:'Avaktivering av iOS-versioner under 1.4(193) (endast Ypsopump) 16/03/2026',
    body_87:'Kära CamAPS FX-användare, av cybersäkerhetsskäl kommer VERSIONER UNDER 1.4(193) att AVAKTIVERAS den 31 mars. Säkerställ att din app är UPPDATERAD till version 1.4(193) före detta datum. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundservice.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'',
    body_82:'',

    header_81:'Uppdatering av Android-appen (endast Ypsopump) 26/01/2026',
    body_81:'Kära CamAPS FX-användare, en NY VERSION av applikationen kommer att finnas tillgänglig om några dagar - 1.4(190). DEAKTIVERAR CamAPS FX AUTOMATISK UPPDATERING i App Store för att välja din föredragna uppdateringstid. Av cybersäkerhetsskäl kommer versioner UNDER 1.4(190) att AVSLUTAS den 31 mars. Om du har några frågor, vänligen kontakta mylife-Diabetescare kundtjänst.',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Meddelande från mylife-Diabetescare (endast YpsoPump) 09/12/2025',
    body_74:'Du kan återfylla din mylife YpsoPump-reservoar en gång  inom 7 dagar efter den första fyllningen. Läs mer på sidan för reservoaren på mylife-diabetescares hemsida.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Viktig säkerhetsinformation om din FreeStyle Libre 3-systemsensor 25/11/2025',
    body_70:'Abbott har identifierat att vissa sensorer FreeStyle Libre 3 och FreeStyle Libre 3 Plus kan visa falskt låga glukosvärden. Gå till',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: 'för att kontrollera om din aktuella eller oanvända sensor är potentiellt påverkad. Om dina sensoravläsningar inte stämmer med dina symtom eller förväntningar, stäng av Auto-läge och använd en blodglukosmätare för att fatta behandlingsbeslut. Om du har frågor eller behöver rapportera problem med din sensor i FreeStyle Libre 3-systemet, kontakta Abbott Kundservice på 020-190 11 11. Ditt nuvarande sensorns serienummer finns i appmenyn under avsnittet Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'iOS-appuppdatering (endast YpsoPump) 25/11/2025',
    body_69:'Kära mylife CamAPS FX-användare, en NY VERSION av applikationen kommer att vara tillgänglig inom de närmaste dagarna. DEAKTIVERA CamAPS FX AUTOMATISKA UPPDATERINGAR i App Store för att välja din föredragna uppdateringstid. Din nuvarande version kommer att AVSLUTAS den 9 december 2025. Om du har några frågor, vänligen kontakta Ypsomed Kundtjänst.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'SÄKERHETSMEDDELANDE TILL MARKNADEN 28/10/2025',
    body_62:'Vänligen läs av viktigt rådgivande meddelande',
    body_62_link_text:'N-0125',
    body_62_end: '. Gå till appmeny -> Säkerhetsmeddelanden.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+SE+final.pdf',

    header_61:'iOS-appuppdatering (endast YpsoPump) 02/10/2025',
    body_61:'För optimal appprestanda, vänligen UPPDATERA din mylife CamAPS FX till den SENASTE VERSIONEN (1.4(192)) via Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'iOS app-uppdatering (endast YpsoPump) 22/09/2025',
    body_59:'Kära mylife CamAPS FX-användare, en NY VERSION av applikationen kommer att vara tillgänglig inom de närmaste dagarna. DEAKTIVERA CamAPS FX AUTOMATISKA UPPDATERINGAR i App Store för att välja din föredragna uppdateringstid. En ny version av användarmanualen kommer att finnas tillgänglig. Om du har några frågor, vänligen kontakta Ypsomed kundservice.',

    header_58:'iOS 26-release (endast YpsoPump) 13/09/2025',
    body_58:'Apple kommer snart att släppa iOS 26. För att säkerställa oavbruten användning av applikationen mylife CamAPS FX, vänligen kontrollera sensorproducentens webbplats för att verifiera kompatibiliteten mellan smartphone och operativsystem innan du uppdaterar din iPhone till iOS 26. Observera: Automatiska uppdateringar kan vara aktiverade som standard i din telefons inställningar, vänligen stäng av dem.',

    header_57:'Uppdatering av Android-app (endast YpsoPump) 26/08/2025',
    body_57:'Kära mylife CamAPS FX-användare, en ny version av applikationen kommer att vara tillgänglig inom 2 till 3 dagar. Vänligen välj din föredragna uppdateringstid genom att avaktivera den automatiska uppdateringen för CamAPS FX i Google Play Store. En ny version av användarmanualen kommer att finnas tillgänglig. Om du har några frågor, vänligen kontakta Ypsomed kundtjänst.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Avslut av äldre appversioner 01/07/2025',
    body_49:'Den nuvarande versionen kommer att sluta fungera den 1 augusti 2025. Vänligen uppdatera din app till den senaste versionen som finns tillgänglig på Google Play.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Av säkerhetsskäl kommer mylife CamAPS FX från och med den 1 augusti  2025 endast att stödjas på sensor-kompatibla telefoner med Android-operativsystem 12 och högre. Användare av operativsystem under OS 12 kommer inte längre att kunna uppdatera eller ominstallera mylife CamAPS FX efter detta datum.',

    header_47:'',
    body_47:'',

    header_46:'iOS-uppdatering 09/06/2025',
    body_46:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja önskad uppdateringstid, vänligen avaktivera automatiska uppdateringar. Om du har några frågor, vänligen kontakta Ypsomeds kundtjänst.',

    header_45:'Android OS 16 09/06/2025',
    body_45:'För att säkerställa att CamAPS FX-applikationen fungerar utan avbrott, kontrollera sensor­tillverkarens webbplats för att verifiera kompatibiliteten mellan din smartphone och operativsystemet innan du uppdaterar till Android OS 16. Observera: Automatiska uppdateringar kan vara aktiverade som standard i telefonens inställningar.',

    header_44:'',
    body_44:'',

    header_43:'',
    body_43:'',

    header_42:'En ny appversion (iOS) 28/04/2025',
    body_42:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja önskad uppdateringstid, vänligen avaktivera automatiska uppdateringar. Om du har några frågor, vänligen kontakta Ypsomeds kundtjänst.',
	
    header_41:'Uppdatering av användarhandboken 24/03/2025',
    body_41:'En uppdaterad version av användarhandboken finns tillgänglig.',

    header_40:'En ny appversion 06/03/2025',
    body_40:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Avslutande av den gamla appversionen (endast Ypsopump)',
    body_37:'Den nuvarande versionen kommer att sluta fungera den 7 februari 2025. Vänligen uppdatera din app till den senaste versionen som finns tillgänglig på Google Play.',

    header_36:'',
    body_36:'',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Av säkerhetsskäl kommer mylife CamAPS FX från och med den 1 januari 2025 endast att stödjas på sensor-kompatibla telefoner med Android-operativsystem 10 och högre. Användare av operativsystem under OS 10 kommer inte längre att kunna uppdatera eller ominstallera mylife CamAPS FX efter detta datum. Påminnelse, systemet är ännu inte kompatibelt med OS15',
	
	header_34:'En ny appversion 09/12/2024',
    body_34:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',
	
	header_33:'Meddelande om planerat underhåll 05/12/2024',
    body_33:'På grund av planerat underhåll av CamAPS FX Service Cloud kommer Companion-funktionen att vara otillgänglig den 7 december från kl. 10:00 GMT i cirka tre timmar. Vi beklagar eventuella besvär detta kan orsaka.',
	
	header_32:'Uppdatering av användarhandboken 28/11/2024',
    body_32:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_31:'En ny appversion 17/11/2024',
    body_31:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Av säkerhetsskäl kommer mylife CamAPS FX från och med den 1 januari 2025 endast att stödjas på sensor-kompatibla telefoner med Android-operativsystem 10 och högre. Användare av operativsystem under OS 10 kommer inte längre att kunna uppdatera eller ominstallera mylife CamAPS FX efter detta datum',
	
	header_29:'En ny appversion 09/10/2024',
    body_29:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 48 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Av säkerhetsskäl kommer mylife CamAPS FX från och med den 1 januari 2025 endast att stödjas på sensor-kompatibla telefoner med Android-operativsystem 10 och högre. Användare av operativsystem under OS 10 kommer inte längre att kunna uppdatera eller ominstallera mylife CamAPS FX efter detta datum',
	
	header_27:'En ny appversion 12/05/2024',
    body_27:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 24 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',
	
	header_26:'Uppdatering av användarhandboken 11/05/2024',
    body_26:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_25:'',
    body_25:'',
	
	header_24:'',
    body_24:'',
	
	header_23:'En ny appversion 24/04/2024',
    body_23:'Kära mylife CamAPS FX-användare, En ny appversion kommer att vara klar inom de närmaste 24 timmarna. För att välja din föredragna uppdateringstid, inaktivera automatisk uppdatering för CamAPS FX i Google Play Butik. Om du har några frågor, vänligen kontakta Ypsomeds kundservice.',
	
	header_22:'Uppdatering av användarhandboken 21/04/2024',
    body_22:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Uppdatering av användarhandboken 04/03/2024',
    body_16:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_15:'Uppdatering av användarhandboken 04/01/2024',
    body_15:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Påminnelse: För att säkerställa en oavbruten användning av mylife CamAPS FX-applikationen, kontrollera sensortillverkarens webbplats för att verifiera kompatibiliteten innan du uppdaterar till Android OS 14. Observera: Automatiska uppdateringar kan vara aktiverade som standard i din telefons inställningar.',
	
	header_13:'SÄKERHETSMEDDELANDE TILL MARKNADEN 14/11/2023',
    body_13:'SÄKERHETSMEDDELANDE TILL MARKNADEN ',
    body_13_link_text:'Vänligen läs av viktigt rådgivande meddelande',
    body_13_end: '. Gå till appmeny -> Säkerhetsmeddelanden.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+-+SE+v2.pdf',

	header_12:'Uppdatering av användarhandboken 10/11/2023',
    body_12:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'För att säkerställa en oavbruten användning av mylife CamAPS FX-applikationen, kontrollera sensortillverkarens webbplats för att verifiera kompatibiliteten innan du uppdaterar till Android OS 14. Observera: Automatiska uppdateringar kan vara aktiverade som standard i din telefons inställningar.Kontrollera att du använder mylife CamAPS FX app version 1.4(173) innan du uppdaterar till Android OS 14.',
	
	header_10:'SÄKERHETSMEDDELANDE TILL MARKNADEN 15/08/2023',
    body_10:'SÄKERHETSMEDDELANDE TILL MARKNADEN Vänligen läs av viktigt rådgivande meddelande. Gå till appmeny -> Säkerhetsmeddelanden.',
	
	header_9:'Uppdatering av användarhandboken 27/07/2023',
    body_9:'En uppdaterad version av användarhandboken finns tillgänglig.',
	
	header_8:'Glooko Kompatibilitet 21/07/2023',
    body_8:'Som tidigare meddelats kommer diasend att avbrytas den 28 juli. Om du vill fortsätta dela data med ditt diabetesteam, uppgradera din diasend-konto till Glooko eller skapa ett nytt Glooko-konto. Vänligen uppdatera till den senaste versionen av mylife CamAPS FX, ange ditt nya Glooko-användarnamn och lösenord i delningsmenyn och starta om din smartphone. Diasend kommer att vara tillgängligt för att visa historisk data under resten av året.',
	
	header_7:'Samsung A-seriens modeller 14/07/2023',
    body_7:'Användare av Samsung A-seriens modeller (t.ex. A53, A33) kan ha upplevt signalbortfall till sin CGM-sensor efter den senaste Samsung One UI 5.1-uppdateringen. Samsung har identifierat problemet och en lösning är under utveckling. Samsung planerar att släppa en uppdatering till One UI den 24 juli (beroende på din region), vilket kommer att lösa signalbortfallsproblemet. Det rekommenderas att installera uppdateringen så snart den blir tillgänglig. Om du ännu inte har uppdaterat till One UI 5.1 rekommenderar vi att vänta på nästa Samsung One UI-uppdateringen.',

    header_6:'Glooko Kompatibilitet (Endast Ypsopump) 14/06/2023',
    body_6:'mylife CamAPS FX är kompatibel med Glooko. Vänligen uppdatera din mittliv CamAPS FX-app till version 1.4(172). Om du delar data med en klinik kommer du att få meddelande inom ditt befintliga diasend-konto när din klinik uppgraderar till Glooko. När uppgraderingen är klar, ange ditt nya Glooko-användarnamn och lösenord i delningsmenyn och starta om din smartphone. Vänligen uppgradera till Glooko före den 28 juli 2023. Diasend kommer att vara tillgängligt för att visa historisk data under resten av året.',

    header_5:'',
    body_5:'',

    header_4:'Uppdatering av användarhandboken 27/05/2023 ',
    body_4:'En uppdaterad version av användarhandboken finns tillgänglig.',

    header_3:'SMS-notifikationer (Endast Ypsopump) 11/05/2023',
    body_3:'Med den kommande uppdateringen 1.4(171) i mitten av maj kommer du kunna aktivera upp till 5 SMS-följare OCH använda Companion-läge samtidigt. För att använda Companion-läget måste användarens telefon ha en internetanslutning för att dela data. Användare måste ha ett SIM-kort för att tillåta att SMS skickas från deras telefon. Om du använder någon av dessa alternativ rekommenderar vi att du kontrollerar att ditt abonnemang inkluderar SMS och/eller data täckning beroende på vilket alternativ du använder.',

    header_2:'Uppdatering om cybersäkerhet (Endast Ypsopump) 24/04/2023',
    body_2:'Meddelande:Säkerheten i mylife CamAPS FX-appen är av yttersta vikt. Från och med mitten av maj kommer det att finnas en uppdatering av cybersäkerheten som är påtvingad av Google Play Store. Efter denna uppdatering kan en liten andel av telefonerna misslyckas med integritetskontrollen av cybersäkerheten. Du kan testa telefonen i förväg genom att gå till hjälpmenyn och fylla i kontrollen. Om telefonen inte klarar av denna kontroll kan du försöka avinstallera och installera appen på nytt.',

    header_1:'',
    body_1:'',
};
